import { computed, action } from 'mobx';
import Collection from '~/glm/models/collection';

export default class GdsHouseholdCollection extends Collection {
  @computed
  get allGuests() {
    const guests = [];
    this.models.forEach(household => {
      household.members.forEach(guest => guests.push(guest));
    });
    return guests;
  }

  getHouseholdById(householdId) {
    return this.models.get(householdId);
  }

  @computed
  get guestsCount() {
    return this.allGuests.length;
  }

  @computed
  get householdsCount() {
    return this.size;
  }

  @action
  removeInvitations(eventId) {
    this.models.forEach(household => {
      household.members.forEach(member => {
        member.invitations.forEach(invitation => {
          if (invitation.eventId === eventId) {
            member.removeInvitation(invitation);
          }
        });
      });
    });
  }
}
